const WizardSaveTypesEnum = {
  SAVE: 'SAVE',
  SAVE_AND_PREVIEW: 'SAVE_AND_PREVIEW',
  SAVE_AND_NEXT: 'SAVE_AND_NEXT',
};

export default WizardSaveTypesEnum;
